export default "__VITE_ASSET__ryGrU$vk__"